<template>
	<carousel
		:paginationEnabled="false"
		:navigationEnabled="false"
		:autoplay="true"
		:autoplayTimeout="7000"
		:autoplayHoverPause="true"
		:perPage="1"
	>
		<slide v-for="(banner, idx) in banners" :key="idx">
			<a
				v-if="banner.external"
				:href="banner.route"
				target="_blank"
				rel="noopener noreferrer"
			>
				<img class="slider__item" :src="banner.src" :alt="banner.alt" />
			</a>
			<router-link v-else :to="banner.route">
				<img class="slider__item" :src="banner.src" :alt="banner.alt" />
			</router-link>
		</slide>
	</carousel>
</template>
<script>
export default {
	name: "Slider",
	props: {
		banners: {
			type: Array,
			required: true,
		},
	},
	data() {
		return {
			name: "slider",
			options: {
				autoplay: {
					delay: 7000,
					disableOnInteraction: true,
				},
				direction: "horizontal",
				grabCursor: true,
				setWrapperSize: true,
				autoHeight: true,
				loop: true,
				pagination: {
					el: ".swiper-pagination",
					clickable: true,
				},
				paginationClickable: true,
				autoplayDisableOnInteraction: false,
			},
		};
	},
	methods: {},
};
</script>
<style lang="scss">
.slider {
	height: auto;
	margin-bottom: -3px;
	width: 100%;
	&__item {
		width: 100%;
		height: auto;
	}
}
</style>
